import { createTheme } from '@fluentui/react';
import { darkSurfaces } from './surfaces';

export const darkTheme = createTheme({
    isInverted: true,
    palette: {
        themePrimary: '#0078d4',
        themeLighterAlt: '#0a1520',
        themeLighter: '#132b44',
        themeLight: '#1b3d5c',
        themeTertiary: '#71afe5',
        themeSecondary: '#2b88d8',
        themeDarkAlt: '#106ebe',
        themeDark: '#005a9e',
        themeDarker: '#004578',
        // Neutral ramp anchored on a black canvas: each step is a slightly
        // lighter gray so cards/menus read as raised above the black background.
        neutralLighterAlt: '#1b1b1b',
        neutralLighter: '#242424',
        neutralLight: '#2b2b2b',
        neutralQuaternaryAlt: '#333333',
        neutralQuaternary: '#3d3d3d',
        neutralTertiaryAlt: '#4a4a4a',
        neutralTertiary: '#c8c8c8',
        neutralSecondaryAlt: '#cacaca',
        neutralSecondary: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        accent: '#0078d4',
        black: '#f8f8f8',
        blackTranslucent40: 'rgba(248,248,248,.4)',
        // Inverted "white" = the default raised container surface (gray).
        white: '#242424',
        whiteTranslucent40: 'rgba(36,36,36,.4)',
    },
    semanticColors: {
        infoBackground: '#004578',
        errorText: '#e3323a',
        // Black app canvas; gray surfaces are layered on top via the palette.
        bodyBackground: '#000000',
        bodyBackgroundChecked: '#1d1d1d',
        bodyText: '#ffffff',
        bodySubtext: '#d0d0d0',
        listItemBackgroundChecked: '#1d1d1d',
        bodyDivider: '#2b2b2b',
        successBackground: 'rgb(16,124,16,.2)',
        warningBackground: 'rgba(255, 185, 0, 0.2)',
        errorBackground: 'rgba(232, 17, 35, 0.2)',
        inputBackground: '#1d1d1d',
        inputText: '#ffffff',
        inputBorder: '#595959',
        inputBorderHovered: '#c8c8c8',
        buttonBackground: '#242424',
        buttonText: '#ffffff',
        buttonBorder: '#3d3d3d',
        disabledText: '#595959',
        disabledBackground: '#1b1b1b',
        menuBackground: '#242424',
        menuItemBackgroundHovered: '#2e2e2e',
    },
});

darkTheme.surfaces = darkSurfaces;
